var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "home",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    d: "M1.8,15A1.9,1.9,0,0,1,0,12.957V5.466a.651.651,0,0,1,.24-.545L5.64.153a.5.5,0,0,1,.72,0l5.4,4.767a.651.651,0,0,1,.24.545v7.491A1.9,1.9,0,0,1,10.2,15Z",
    transform: "translate(0 0)",
    fill: "#068ecf"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_146",
    "data-name": "Group 146",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask-2",
    "data-name": "Mask",
    d: "M1.8,15A1.9,1.9,0,0,1,0,12.957V5.466a.651.651,0,0,1,.24-.545L5.64.153a.5.5,0,0,1,.72,0l5.4,4.767a.651.651,0,0,1,.24.545v7.491A1.9,1.9,0,0,1,10.2,15Z",
    transform: "translate(0 0)",
    fill: "#068ecf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_146",
    "data-name": "Mask Group 146",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_14_Icon_Color_Symbol",
    "data-name": "14) Icon Color Symbol",
    transform: "translate(-1.2 -0.682)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_Icon_Color",
    "data-name": "\\uD83C\\uDFA8 Icon Color",
    width: 14.4,
    height: 16.363,
    fill: "#068ecf"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/HomeIcon.990828b35cd6c2005e3260dd2a64c671.svg";
export { ForwardRef as ReactComponent };